import { getPageUrl } from '@/helpers/breadcrumbs'
import { getTimeAgo } from '@/helpers/date'
import { populated } from '@/helpers/populated'
import { transformImage } from '@/helpers/transforms'
import type { NewsArticlesCarouselBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import type { CardVideoType } from '../atoms/CardVideo'
import { CarouselVideoCardsBlock } from '../blocks/CarouselVideoCardsBlock'

export const NewsArticlesCarouselConverter: JSXConverter<
	SerializedBlockNode<NewsArticlesCarouselBlock>
> = ({ node }) => {
	const { articles } = node.fields

	const articlesData: CardVideoType[] = []

	if (!articles) {
		return null
	}

	for (const article of articles) {
		if (populated(article) && article.newsArticle) {
			const { heroImage, publishDate, video } = article.newsArticle

			const imageData = transformImage(heroImage)

			const articleData: CardVideoType = {
				id: article.id,
				image: imageData,
				label: populated(article.parent) ? (article.parent?.title ?? '') : '',
				title: article.title,
				date: getTimeAgo(publishDate),
				href: getPageUrl(article),
				video: video ? true : false,
			}

			articlesData.push(articleData)
		}
	}

	return <CarouselVideoCardsBlock cards={articlesData} />
}
